import { Injectable } from '@angular/core';
import { URLS } from '../constants/constants';
import { HeaderType } from '../enums/enums';
import { BlogFilter } from '../interface/interface';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class BlogsService {
  constructor(private http: HttpService) {}

  addBlog(payload: any) {
    return this.http.post(`${URLS.blogs}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  getBlog(id: string) {
    return this.http.get(`${URLS.blogs}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }
  getBlogList(value: BlogFilter) {
    return this.http.get(`${URLS.blogs}`, {
      params: {
        headerType: HeaderType.ACCESS,
        search: value.searchText,
        page: value.pageNumber,
        limit: value.limit,
        categorySlug: value.categorySlug,
      },
    });
  }
  deleteBlog(id: string) {
    return this.http.delete(`${URLS.blogs}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }
  updateBlog(id: string, payload: any) {
    return this.http.put(`${URLS.blogs}/${id}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }
}
